import { Box, Card, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import cssClasses from "./PANConflictCard.module.css";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import Button from "../../../Subcomponents/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CallIcon from "@mui/icons-material/Call";
import { DataGrid } from "@mui/x-data-grid";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CustomInput from "../../../Subcomponents/CustomInput";
import Divider from "@mui/material/Divider";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//service
import { errorTost, successTost } from "../../../Services/Toast";

import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { WhatsappIcon } from "react-share";
import DropDown from "../../../Subcomponents/DropDown";
import { getSiteVisitForConflicts } from "../../../Services/SiteVisit";
import ProjectIcon from '../../../Assets/Images/Sustenance/ProjectIcon.svg';
import ViewSiteVisitDetails from "../../../Modals/ViewSiteVisitDetails/ViewSiteVisitDetails";

const dataGridStyles = {
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    border: "1px solid #EAECF0 !important",
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    fontFamily: "Inter-Medium",
    borderRadius: "8px",
    '& div[data-colindex="1"]': {
      color: "#101828",
      fontWeight: "500",
    },
    "& .MuiDataGrid-virtualScrollerRenderZone": {
      "& .MuiDataGrid-row": {
        borderBottom: "1px solid #EAECF0",
        background: "#FFFFFF",
        /* Shadow/xl */
  
        // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        borderRadius: "1rem",
  
        //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
        //   backgroundColor: "#FFFFFF",
      },
      "& .MuiDataGrid-row.Mui-selected:hover": {
        borderBottom: "1px solid #EAECF0",
        backgroundColor: "#FFFFFF",
        // "&:nth-of-type(2n+1)": {
        //   backgroundColor: "rgba(249, 250, 251, 1)",
        // },
      },
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader:hover": {
      "& .MuiDataGrid-menuIcon": {
        visibility: "hidden",
      },
    },
  
    "&  .MuiDataGrid-columnHeaders": {
      background: "#F9FAFB",
      /* Gray/200 */
      border: "1px solid #EAECF0",
      /* Shadow/xl */
      // boxShadow:
      //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      // borderRadius: "8px",
  
      marginBottom: "1rem",
      borderBottom: "6px solid #EAECF0",
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-checkboxInput": {
      "& svg": {
        width: "2rem",
        height: "2rem",
        background: "#FFFFFF",
      },
    },
    // "& .MuiTablePagination-displayedRows": {
    //   display: "none",
    // },
    "& .MuiDataGrid-footerContainer": {
      "& .MuiTablePagination-displayedRows ": {
        display: "none",
      },
      "& .MuiDataGrid-selectedRowCount": {
        visibility: "hidden ",
      },
    },
    "&  [title='Sort']": {
      //visibility:"hidden",
      display: "none",
      cursor: "none",
    },
    "& [title='Go to previous page']": {
      borderRadius: "0",
      border: "1px solid #EAECF0",
      borderRadius: "0.8rem",
      marginRight: "0.5rem",
    },
    "& [title='Go to next page']": {
      borderRadius: "0",
      border: "1px solid #EAECF0",
      borderRadius: "0.8rem",
      marginRight: "0.5rem",
    },
    "& [title='Go to previous page']:after": {
      content: "'Previous'",
      marginLeft: "1rem",
    },
    "& [title='Go to next page']:before": {
      content: "'Next'",
      marginRight: "1rem",
    },
    "& .MuiDataGrid-columnHeader": {
      padding: "0 4rem",
  
      "&:focus": {
        outline: "none",
      },
    },
    "&  .MuiDataGrid-row ": {
      maxHeight: "72px !important",
      minHeight: "72px !important",
    },
    "& .MuiDataGrid-cell": {
      padding: "0 4rem",
      minHeight: "72px !important",
      maxHeight: "72px !important",
      "&:focus": {
        outline: "none",
      },
    },
    "& .MuiButtonBase-root": {
      fontSize: "1.6rem",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
  };

export default function PANConflictCard({
    leadObj,
    tabValue,
    CardType,
}) {
    let loggedInUser = {};
    loggedInUser = useSelector((state) => state.Auth.user);
    TimeAgo.setDefaultLocale(en.locale);
    TimeAgo.addLocale(en);

    const leadTypeList = ["WARM", "HOT", "COLD", "LOST"];
    const [dropdownList, setDropdownList] = useState([]);

    const [showDetails, setShowDetails] = useState(false);
    const [style, setStyle] = useState(null);
    const [copyLeadObj, setCopyLeadObj] = useState(leadObj);
    const [leadToken, setLeadToken] = useState([]);
    const [siteVisitData, setSiteVisitData] = useState(null)
    const [ViewSiteData, setViewSiteData] = useState('');
    const [openViewDetails, setOpenViewDetails] = useState(false);


    const WhatsAppMessage = `Hello Mr.${leadObj.leadname}%0a %0a,Greetings from Vilas Javdekar Developers !%0a %0aYour current Status:${leadObj.leadstatus}.%0a %0aCustomer Portal link:${process.env.REACT_APP_CUSTOMER_PORTAL}`;
    useEffect(() => {
        setCopyLeadObj(leadObj)
    }, [leadObj])

    // console.log("leadObj", leadObj)
    const CpColumns = [
        {
          field: 'Site',
          headerName: 'Leads',
          width: 440,
          renderCell: (params) => {
            return (
              <Box className={cssClasses.SubContainer}>
                  <img src={ProjectIcon} alt={''} />
                <Box>
                  <Box className={cssClasses.BoldTitle} whiteSpace={'break-spaces'}>
                    {params?.row?.leadId?.personId?.name}
                  </Box>
                  <Box>
                    <Box
                      component={'span'}
                      className={cssClasses.semiBoldTitle}
                      whiteSpace={'break-spaces'}
                    >
                      VJ
                      {params?.row?.leadId?.leadDisplayId
                        ? params?.row?.leadId?.leadDisplayId?.replace(
                            params?.row?.leadId?.leadDisplayId?.substring(8, 12),
                            '-' + params?.row?.leadId?.leadDisplayId?.substring(8, 12)
                          )
                        : '-'}
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          },
        },
        {
          field: 'Cp&Fos',
          headerName: 'Channel Partners and their FOS',
          width: 350,
          renderCell: (params) => {
            return (
              <Box className={cssClasses.SubContainer}>
                <Box>
                  <Box className={cssClasses.BoldTitle}>
                    CP :{' '}
                    <Box
                      component={'span'}
                      className={cssClasses.semiBoldTitle}
                      whiteSpace={'break-spaces'}
                    >
                      {' '}
                      {params?.row?.cpId?.billingname ? params?.row?.cpId?.billingname : 'NA'}
                    </Box>
                  </Box>
                  <Box className={cssClasses.BoldTitle}>
                    FOS :{' '}
                    <Box
                      component={'span'}
                      className={cssClasses.semiBoldTitle}
                      whiteSpace={'break-spaces'}
                    >
                      {params?.row?.fosId?.name ? params?.row?.fosId?.name : 'NA'}
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          },
        },
        {
          field: 'Sales',
          headerName: 'Sales Representative',
          width: 250,
          renderCell: (params) => {
            return (
              <Box className={cssClasses.SubContainer}>
                <Box className={cssClasses.BoldTitle} whiteSpace={'break-spaces'}>
                  {params?.row?.userId?.name ? params?.row?.userId?.name : '-'}
                </Box>
              </Box>
            );
          },
        },
        {
          field: 'VisitDateTime',
          headerName: 'Visit Date & Time ',
          width: 300,
          renderCell: (params) => {
            return (
              <Box whiteSpace={'break-spaces'}>
                {new Date(params.row.dateTime).toDateString()},{' '}
                {new Date(params.row.dateTime).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </Box>
            );
          },
        },
        {
          field: 'action',
          headerName: 'Action',
          width: 180,
          renderCell: (params) => {
            return (
              <Button
                style={{
                  color: '#155EEF',
                  backgroundColor: '#FFF',
                  border: '1px solid #155EEF',
                  fontSize: '1.4rem',
                  lineHeight: '2rem',
                }}
                btnName={'View Details'}
                padding={'0.5rem 2.5rem'}
                clicked={() => {
                  setViewSiteData(params.row);
                  handleViewDetailsOpen();
                }}
              />
            );
          },
        },
      ];
      const handleViewDetailsOpen = () => setOpenViewDetails(true);
      const handleViewDetailsClose = () => setOpenViewDetails(false);
    function toCalculateValueFromPercent(percentage, bsp) {
        var numVal1 = Number(bsp);
        var numVal2 = Number(percentage) / 100;

        var totalValue = numVal1 * numVal2;

        return Math.ceil(totalValue);
    }
    function defineColorSchema() {
        let obj = {};
        let tempSideMenuArray = [];
        if (copyLeadObj.status === "Claimed") {
            obj.chipColor = "#FF4405";
            obj.chipBackgroundColor = "#FFE6D5";

        } else if (
            copyLeadObj.status === "Site Visit Done" ||
            copyLeadObj.status === "Token Partial Payment Done" ||
            copyLeadObj.status === "Token Refund Requested"
        ) {
            obj.chipColor = "#5925DC";
            obj.chipBackgroundColor = "#F4F3FF";
        } else if (copyLeadObj.status === "Site Visit Scheduled") {
            obj.chipColor = "#5925DC";
            obj.chipBackgroundColor = "#F4F3FF";

        } else if (copyLeadObj?.status === "Site Visit Pending") {
            obj.chipColor = "#0E7090";
            obj.chipBackgroundColor = "#ECFDFF";

        } else if (
            copyLeadObj?.status === "Token Payment Pending" ||
            copyLeadObj?.status === "Token Payment Not Done"
        ) {
            obj.chipColor = "#C11574";
            obj.chipBackgroundColor = "#FDF2FA";

        } else if (
            copyLeadObj?.status === "Token Payment Complete" ||
            copyLeadObj?.status === "Token Refund Request Rejected" ||
            copyLeadObj?.status === "Token Payment Pending"
        ) {
            obj.chipColor = "#3538CD";
            obj.chipBackgroundColor = "#EEF4FF";

        } else if (copyLeadObj?.status === "Token Refunded") {
            obj.chipColor = "#3538CD";
            obj.chipBackgroundColor = "#EEF4FF";

        } else if (copyLeadObj?.status === "Checkpoint One Cleared") {
            obj.chipColor = "#6941C6";
            obj.chipBackgroundColor = "#F4EBFF";

        } else if (copyLeadObj?.status === "Checkpoint Two Cleared") {
            obj.chipColor = "#0E7090";
            obj.chipBackgroundColor = "#ECFDFF";

        } else if (
            copyLeadObj.status === "Allotment Partial Payment Done" ||
            copyLeadObj.status === "Allotment Refunded" ||
            copyLeadObj.status === "Preselect payment not done"
        ) {
            obj.chipColor = "#C01048";
            obj.chipBackgroundColor = "#FFF1F3";

        } else if (copyLeadObj.status === "Unit On Hold") {
            obj.chipColor = "#C01048";
            obj.chipBackgroundColor = "#FFF1F3";

        } else if (
            copyLeadObj.status === "Allotment Payment Pending" ||
            copyLeadObj.status === "Payment Pending"
        ) {
            obj.chipColor = "#C01048";
            obj.chipBackgroundColor = "#FFF1F3";

        } else if (copyLeadObj.status === "Change Unit Confirmation Pending") {
            obj.chipColor = "#C01048";
            obj.chipBackgroundColor = "#FFF1F3";

        } else if (
            copyLeadObj.status === "Allotment Payment Complete" ||
            copyLeadObj.status === "Agreement Done" ||
            copyLeadObj.status === "Change Unit Requested" ||
            copyLeadObj.status.includes("Cancellation Confirmation Pending") ||
            copyLeadObj.status === "Cancellation Done" ||
            copyLeadObj.status === "Cancellation Not Done" ||
            copyLeadObj.status === "Change Unit Confirmation Rejected" ||
            copyLeadObj.status === "Change Unit Confirmed" ||
            copyLeadObj.status === "Cancellation Pending" ||
            copyLeadObj.status === "Change Unit Rejected" ||
            copyLeadObj.status === "Cancel Unit Requested" ||
            copyLeadObj.status === "PreSelect Payment Pending" ||
            copyLeadObj.status === "PreSelect Unit On Hold" ||
            copyLeadObj.status === "Preselect not confirmed" ||
            copyLeadObj.status === "PreSelect Partial Payment Done" ||
            copyLeadObj.status === "PreSelect Price Confirmation Pending" ||
            copyLeadObj.status === "PreSelect Confirmation Pending" ||
            copyLeadObj.status === "PreSelect Confirmation Pending" ||
            copyLeadObj.status === "Unit Change Requested"
        ) {
            obj.chipColor = "#5925DC";
            obj.chipBackgroundColor = "#F4F3FF";
        } else if (
            copyLeadObj.status === "PreSelect Confirmation Pending" ||
            copyLeadObj.status === "PreSelect Price Confirmation Pending"
        ) {
            obj.chipColor = "#C01048";
            obj.chipBackgroundColor = "#FFF1F3";
        } else if (copyLeadObj.status === "PreSelect Payment Pending") {
            obj.chipColor = "#6941C6";
            obj.chipBackgroundColor = "#F4EBFF";

        } else if (copyLeadObj.status === "Closed") {
            obj.chipColor = "#027A48";
            obj.chipBackgroundColor = "#ECFDF3";

        } else {
            obj.chipBackgroundColor = "#ececec";
        }

        if (copyLeadObj.leadStatus === "HOT") {
            obj.leadStatusColor = "#B42318";
        } else if (copyLeadObj.leadStatus === "COLD") {
            obj.leadStatusColor = "#175CD3";
        } else if (copyLeadObj.leadStatus === "WARM") {
            obj.leadStatusColor = "#F79009";
        } else {
            obj.leadStatusColor = "#667085";
        }
        if (copyLeadObj.unit?.status === "On Hold") {
            obj.unitChipColor = "#E62E05";
            obj.unitChipBackgroundColor = "#FFF4ED";
        } else if (copyLeadObj.unit?.status === "Done") {
            obj.unitChipColor = "#027A48";
            obj.unitChipBackgroundColor = "#ECFDF3";
        }
        setStyle(obj);
    }
    function numberWithCommas(x) {
        return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
    }

    useEffect(() => {
        defineColorSchema();
    }, [copyLeadObj?.leadId?.LeadStatus[0]?.status]);
    useEffect(() => {
        getSiteVisitForConflicts(copyLeadObj?.panconflic_sitevisitid).then((resp)=> {console.log("site resp", resp?.data?.[0]); setSiteVisitData(resp?.data)})
    },[])
    function getRowId(row) {
        
        return row.siteVistId;
      }
    //Token Columns
    const columns = [
        {
            field: "tokenName",
            headerName: "Token Name",
            width: 250,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.status !== "pending" &&
                            params.row.status !== "partial" && (
                                <p className={cssClasses.tokenNumber}>
                                    VJ{params.row.tokenNumber}
                                </p>
                            )}
                        <p className={cssClasses.tokenName}>{params.row.tokenName}</p>
                    </div>
                );
            },
        },

        {
            field: "tokenType",
            headerName: "Token Type",
            width: 150,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.eventTokenId.tokenId.isPreselect ?
                            <div>Preselect</div>
                            :
                            params.row.eventTokenId.tokenId.isPriorityPass ?
                                <div>Priority Pass</div> :
                                <div>Global Token</div>
                        }
                        <div></div>
                        <div>{params.row.tokenType}</div>
                    </div>
                )
            }
        },
        {
            field: "status",
            headerName: "Status",
            width: 200,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem'
                    }}>
                        {params.row.status === "pending" && (
                            <LeadStatusChip
                                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                label={params.row.status}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                        {params.row.status === "active"
                            && !params.row.isPrerequisiteUsed &&
                            (
                                <LeadStatusChip
                                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                    label={params.row.status}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                />
                            )}
                        {params.row.status === "alloted" && (
                            <LeadStatusChip
                                style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                                label={params.row.status}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                        {(params.row.status === "refund requested" ||
                            params.row.status === "refund initiated") && (
                                <LeadStatusChip
                                    style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                                    label={params.row.status}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                />

                            )}
                        {params.row.isPrerequisiteUsed && params.row.status === "active" && (
                            <LeadStatusChip
                                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                                label={'Upgraded'}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                        {(params.row.status === "refunded" ||
                            params.row.status === "refund processed") && (
                                <LeadStatusChip
                                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                                    label={params.row.status}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                />
                            )}
                        {params.row.status === "expired" && (
                            <LeadStatusChip
                                style={{ color: "#B54708", backgroundColor: "#FFF4ED" }}
                                label={params.row.status}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                        {params.row.status === "partial" && (
                            <LeadStatusChip
                                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                                label={params.row.status}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                        {params.row.status === "refund rejected" && (
                            <LeadStatusChip
                                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                                label={params.row.status}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                        {params.row.status === "adjusted" && (
                            <LeadStatusChip
                                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                                label={params.row.status}
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                            />
                        )}
                    </div>
                );
            },
        },
        {
            field: "Action",
            headerName: "Valid Upto",
            // type: 'number',
            width: 250,
            renderCell: (params) => {
                let date = new Date(params.row.created_at);
                let tokenExpire = date.setDate(date.getDate() + params.row.validity);
                let validUpto = new Date(tokenExpire);
                return (
                    <div>
                        {validUpto > Date.now() &&
                            params.row.status !== "expired" &&
                            params.row.status !== "refund processed" &&
                            params.row.status !== "refund initiated" &&
                            (
                                <div>
                                    {validUpto.toDateString()},
                                    {new Date(validUpto).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </div>)}
                        {validUpto < Date.now() && params.row.status === "alloted" && (
                            <div>
                                {validUpto.toDateString()},
                                {new Date(validUpto).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}
                            </div>
                        )}
                        {validUpto < Date.now() && params.row.status !== "alloted" && (
                            <LeadStatusChip
                                style={{
                                    color: "#FF4405",
                                    backgroundColor: "#FFE6D5",
                                }}
                                label={"Expired"}
                                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                            />
                        )}
                        {validUpto > Date.now() && (params.row.status === "expired" || params.row.status === "refund processed" ||
                            params.row.status === "refund initiated") && (
                                <LeadStatusChip
                                    style={{
                                        color: "#FF4405",
                                        backgroundColor: "#FFE6D5",
                                    }}
                                    label={"Expired"}
                                    icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                                />
                            )}
                    </div>
                );
            },
        },
        {
            field: "refundable",
            headerName: "Refundable",
            width: 150,
        },
        {
            field: "eventName",
            headerName: "Event Name",
            width: 250,
        },
        {
            field: "paidAmount",
            headerName: "Amount Paid",
            width: 170,
            renderCell: (params) => {
                return (
                    <div>
                        <p className={cssClasses.tokenNumber}>
                            ₹{numberWithCommas(params.row.paidAmount)}
                        </p>
                    </div>
                );
            },
        },
        {
            field: "amount",
            headerName: "Token Amount",
            width: 170,
            renderCell: (params) => {
                return (
                    <div>
                        <p className={cssClasses.tokenNumber}>
                            ₹{numberWithCommas(params.row.amount)}
                        </p>
                    </div>
                );
            },
        },
        {
            field: "tokenCompletionDate",
            headerName: "Token Completion Date",
            width: 200,
            renderCell: (params) => {
                return (
                    <div>
                        <p className={cssClasses.tokenNumber}>
                            {params.row.paymentCompleteDate && (
                                <>
                                    {new Date(params.row.paymentCompleteDate).toDateString()},{" "}
                                    {new Date(params.row.paymentCompleteDate).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </>
                            )}
                        </p>
                    </div>
                );
            },
        },
    ];

    return (
        <Card
            variant="outlined"
            sx={[
                {
                    boxShadow:
                        "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
                    borderRadius: "0.8rem ",
                },
            ]}
        >
            <div className={cssClasses.container}>
                <div className={cssClasses.header}>
                    <div className={cssClasses.headerDiv1}>
                        <div style={{ flex: "0.5" }}>
                            <DropDown
                                disable
                                list={leadTypeList}
                                style={{
                                    background: "#FFF",
                                    selectedColor: style?.leadStatusColor,
                                }}
                                selectedValue={copyLeadObj.leadStatus ?? "WARM"}
                            />
                        </div>
                        <div>
                            <div className={cssClasses.rowWrapper}>
                                <div className={cssClasses.label}>
                                    <p>Type Of Lead</p>
                                </div>
                                <div className={cssClasses.label}>
                                    <p>:</p>
                                </div>
                                <div className={cssClasses.value}>
                                    <p>{copyLeadObj.type}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: "1", padding: "1rem" }}>
                            <LeadStatusChip
                                style={{
                                    color: style?.chipColor,
                                    backgroundColor: style?.chipBackgroundColor,
                                }}
                                label={copyLeadObj.status}
                                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                            />
                        </div>

                    </div>
                    {/* )} */}

                    <div className={cssClasses.headerDiv2}>
                        <div>
                            <ReactTimeAgo
                                style={{ fontSize: "1.2rem" }}
                                date={copyLeadObj?.last_updated_at ?? copyLeadObj?.createdAt}
                                locale="en-US"
                                claimLead
                            />
                        </div>
                    </div>
                </div>
                <div className={cssClasses.content}>
                    <div className={cssClasses.displayChip}>
                        {copyLeadObj?.lead_category &&
                            <LeadStatusChip
                                label={copyLeadObj?.lead_category}
                                // icon={<Dot width={"0.5rem"} height={"0.5rem"}/>}
                                style={{
                                    color: "#A15C07",
                                    backgroundColor: "#FEFDF0",
                                }}
                            />
                        }
                        {copyLeadObj?.isleadunclaimed &&
                            <div>
                                <LeadStatusChip
                                    label={"Lead Churned"}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{
                                        color: "#b54708",
                                        backgroundColor: "#fffaeb"
                                    }}
                                />
                            </div>
                        }
                        <div>
                            <LeadStatusChip
                                label={
                                    copyLeadObj?.razorpaycustomerid || copyLeadObj?.virtualaccid
                                        ? `Virtual Account Created ${copyLeadObj.virtual_acc_status === null ? "" : copyLeadObj.virtual_acc_status === "active" ? " - Active" : " - Closed"}`
                                        : "Virtual Account Not Created"
                                }
                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                style={
                                    copyLeadObj?.razorpaycustomerid &&
                                        copyLeadObj.virtual_acc_status === "closed"
                                        ? {
                                            color: "#b54708",
                                            backgroundColor: "#fffaeb",
                                        }
                                        : copyLeadObj?.razorpaycustomerid === null
                                            ? {
                                                color: "#C01048",
                                                backgroundColor: "#FFF1F3",
                                            }
                                            : {
                                                color: "#027A48",
                                                backgroundColor: "#ECFDF3",
                                            }
                                }
                            />
                        </div>
                    </div>

                    <div className={cssClasses.content1}>
                        <div>
                            <div
                                className={cssClasses.rowWrapper}
                                style={{ alignItems: "baseline", gap: "0.8rem" }}
                            >
                                <div className={cssClasses.leadName}>
                                    <p>{copyLeadObj?.person?.name}</p>
                                </div>
                                <div className={cssClasses.leadId}>
                                    <p>{copyLeadObj?.id}</p>
                                </div>
                            </div>
                            <div className={cssClasses.rowWrapper}>
                                <div className={cssClasses.projectName}>
                                    {/* Event Name | 60-70L | */}
                                    <p>
                                        {copyLeadObj?.project?.unitType} | {copyLeadObj?.project?.name}
                                    </p>
                                </div>
                            </div>
                            <div className={cssClasses.rowWrapper}>
                                <div className={cssClasses.label} style={{ color: "#1D2939" }}>
                                    <CalendarTodayOutlinedIcon style={{ color: "#1D2939" }} />
                                    <p>Created At :</p>
                                </div>
                                <div
                                    className={cssClasses.value}
                                    style={{ color: "#344054", fontFamily: "Inter-Regular" }}
                                >
                                    <p>
                                        {new Date(copyLeadObj?.createdAt).toDateString()},{" "}
                                        {new Date(copyLeadObj?.createdAt).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            {copyLeadObj?.referrerid ? (
                                <div>
                                    <div className={cssClasses.rowWrapper}>
                                        <div className={cssClasses.label}>
                                            <p>Referrer</p>
                                        </div>
                                        <div className={cssClasses.label}>
                                            <p>:</p>
                                        </div>
                                        <div className={cssClasses.value}>
                                            <p>{copyLeadObj?.referrername || "NA"}</p>
                                        </div>
                                    </div>
                                    <div className={cssClasses.rowWrapper}>
                                        <div className={cssClasses.label}>
                                            <p>Unit</p>
                                        </div>
                                        <div className={cssClasses.label}>
                                            <p>:</p>
                                        </div>
                                        <div className={cssClasses.value}>
                                            <p>
                                                {copyLeadObj?.referrerunitno || "NA"} -
                                                {copyLeadObj?.referrerwing || "NA"} |
                                                {copyLeadObj?.referrerproject || "NA"}
                                            </p>
                                        </div>
                                    </div>
                                    <div className={cssClasses.rowWrapper}>
                                        <div className={cssClasses.label}>
                                            <p>Relationship Manager</p>
                                        </div>
                                        <div className={cssClasses.label}>
                                            <p>:</p>
                                        </div>
                                        <div className={cssClasses.value}>
                                            <p>{copyLeadObj?.referrerrelationshipm || "NA"}</p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className={cssClasses.rowWrapper}>
                                        <div className={cssClasses.label}>
                                            <p>FOS</p>
                                        </div>
                                        <div className={cssClasses.label}>
                                            <p>:</p>
                                        </div>
                                        <div className={cssClasses.value}>
                                            {copyLeadObj?.FOS?.name === "-" ? (
                                                <p>NA</p>
                                            ) : (
                                                <p>{copyLeadObj?.FOS?.name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={cssClasses.rowWrapper}>
                                        <div className={cssClasses.label}>
                                            <p>CP</p>
                                        </div>
                                        <div className={cssClasses.label}>
                                            <p>:</p>
                                        </div>
                                        <div className={cssClasses.value}>
                                            {copyLeadObj?.CP?.name === "-" ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "1rem",
                                                    }}
                                                >
                                                    <p>NA</p>
                                                    <span>
                                                        <Tooltip
                                                            title={
                                                                <h1 style={{ color: "lightblue" }}>
                                                                    Lead added by internal sales team hence no FOS or
                                                                    CP present
                                                                </h1>
                                                            }
                                                            disableInteractive
                                                            style={{ fontSize: "2.4rem" }}
                                                        >
                                                            <InfoOutlinedIcon
                                                                style={{
                                                                    fontSize: "2rem",
                                                                    verticalAlign: "middle",
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </div>
                                            ) : (
                                                <p>{copyLeadObj?.CP?.name}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                            }

                            <div className={cssClasses.rowWrapper}>
                                <div className={cssClasses.label}>
                                    <p>VJ SM</p>
                                </div>
                                <div className={cssClasses.label}>
                                    <p>:</p>
                                </div>
                                <div className={cssClasses.value}>
                                    <p>{copyLeadObj?.Sales?.name}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {showDetails &&
                        copyLeadObj?.allotmentData?.map((eachAllotment) => {
                            return (
                                <div style={{ marginTop: "2rem" }}>
                                    <Divider
                                        sx={{
                                            width: "100%",
                                            borderColor: "#EAECF0",
                                            marginBottom: "1.2rem",
                                        }}
                                    />
                                    <div className={cssClasses.projectDiv}>
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "1rem",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div className={cssClasses.projectNameLabel}>
                                                <p>Project Name</p>
                                            </div>
                                            <div className={cssClasses.label}>
                                                <p>:</p>
                                            </div>
                                            <div className={cssClasses.projectNameValue}>
                                                {eachAllotment?.unitId?.projectId?.projectName ? (
                                                    <p>{eachAllotment?.unitId?.projectId?.projectName}</p>
                                                ) : (
                                                    <p>
                                                        {
                                                            eachAllotment?.inventoryMergedId?.projectId
                                                                ?.projectName
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div style={{ display: "flex", gap: "0.5rem" }}>
                                                <div>
                                                    {eachAllotment.pricingType === "preselect" && (
                                                        <LeadStatusChip
                                                            label={"Preselect"}
                                                            icon={
                                                                <Dot width={"0.5rem"} height={"0.5rem"} />
                                                            }
                                                            style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }}
                                                        ></LeadStatusChip>
                                                    )}
                                                </div>
                                                <div>
                                                    {eachAllotment.farvisionCancelled?.cancelledInFarvision === true && (
                                                        <LeadStatusChip
                                                            label={"Cancelled In Farvision"}
                                                            icon={
                                                                <Dot width={"0.5rem"} height={"0.5rem"} />
                                                            }
                                                            style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                                        ></LeadStatusChip>
                                                    )}
                                                </div>
                                                <div>

                                                    {(eachAllotment.status === "Partial Payment Done" ||
                                                        eachAllotment.status === "Payment Complete") &&
                                                        !eachAllotment.kycFormFilled && (
                                                            <LeadStatusChip
                                                                label={"Kyc pending"}
                                                                icon={
                                                                    <Dot width={"0.5rem"} height={"0.5rem"} />
                                                                }
                                                                style={{
                                                                    color: "#0E7090",
                                                                    backgroundColor: "#ECFDFF",
                                                                }}
                                                            ></LeadStatusChip>
                                                        )}
                                                    {eachAllotment.kycFormFilled && (
                                                        <LeadStatusChip
                                                            label={"Kyc Done"}
                                                            icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                            style={{
                                                                color: "#0E7090",
                                                                backgroundColor: "#ECFDFF",
                                                            }}
                                                        ></LeadStatusChip>
                                                    )}
                                                </div>
                                                <div>
                                                    <LeadStatusChip
                                                        style={
                                                            eachAllotment?.status === "pending"
                                                                ? {
                                                                    color: "#B54708",
                                                                    backgroundColor: "#FFFAEB",
                                                                }
                                                                : eachAllotment?.status === "Payment Complete"
                                                                    ? {
                                                                        color: "#027A48",
                                                                        backgroundColor: "#ECFDF3",
                                                                    }
                                                                    : {
                                                                        color: "#B54708",
                                                                        backgroundColor: "#FFF4ED",
                                                                    }
                                                        }
                                                        label={eachAllotment?.status}
                                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={cssClasses.projectDetails}>
                                        <div style={{ marginTop: "1rem", width: "30%" }} className={cssClasses.allotmentEachBlock}>
                                            <p>Unit</p>
                                            {eachAllotment?.unitId !== null ? (
                                                <CustomInput
                                                    value={
                                                        // eachAllotment?.unitId?.wingId?.wingName +
                                                        (eachAllotment?.unitId?.wingId?.displayName ? eachAllotment?.unitId?.wingId?.displayName : eachAllotment?.unitId?.wingId?.wingName) +
                                                        "-" +
                                                        eachAllotment?.unitId?.unitNo
                                                    }
                                                    disabled={true}
                                                />
                                            ) : (
                                                <CustomInput
                                                    value={
                                                        // eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                        //   ?.wingName +
                                                        (eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                            ?.displayName ? eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                            ?.displayName : eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                            ?.wingName) +
                                                        "-" +
                                                        (eachAllotment?.inventoryMergedId?.unit1No) +
                                                        "," +
                                                        // eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                        //   ?.wingName +
                                                        (eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                            ?.displayName ? eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                            ?.displayName : eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                                                            ?.wingName) +
                                                        "-" +
                                                        (eachAllotment?.inventoryMergedId?.unit2No)
                                                    }
                                                    disabled={true}
                                                />
                                            )}
                                        </div>
                                        <div style={{ marginTop: "1rem", width: "20%" }} className={cssClasses.allotmentEachBlock}>
                                            <p>Allotment Date</p>
                                            <CustomInput
                                                // value={new Date(
                                                //   eachAllotment?.last_updated_at
                                                // ).toLocaleDateString()}
                                                value={
                                                    new Date(eachAllotment?.created_at).toDateString()
                                                    // new Date( eachAllotment?.last_updated_at).toLocaleTimeString([], {
                                                    //   hour: "2-digit",
                                                    //   minute: "2-digit",
                                                    //  } )
                                                }
                                                disabled={true}
                                            />
                                        </div>
                                        <div style={{ marginTop: "1rem", width: "15%" }} className={cssClasses.allotmentEachBlock}>
                                            <p>Paid Amount</p>
                                            {eachAllotment?.paidAmount ? (
                                                <CustomInput
                                                    value={
                                                        "₹" + numberWithCommas(eachAllotment?.paidAmount)
                                                    }
                                                    disabled={true}
                                                />
                                            ) : (
                                                <CustomInput
                                                    value={"₹" + eachAllotment?.paidAmount}
                                                    disabled={true}
                                                />
                                            )}
                                        </div>
                                        <div style={{ marginTop: "1rem", width: "15%" }} className={cssClasses.allotmentEachBlock}>
                                            <p>Total Cost</p>
                                            {eachAllotment?.unitCost?.total ? (
                                                <CustomInput
                                                    value={
                                                        "₹" +
                                                        numberWithCommas(eachAllotment?.unitCost?.total)
                                                    }
                                                    disabled={true}
                                                />
                                            ) : (
                                                <CustomInput
                                                    value={"₹0"}
                                                    disabled={true}
                                                />
                                            )}
                                        </div>
                                        <div style={{ marginTop: "1rem", width: "15%" }} className={cssClasses.allotmentEachBlock}>
                                            <p>Basic Brokerage</p>
                                            {eachAllotment?.unitCost?.bsp ? (
                                                <CustomInput
                                                    value={
                                                        "₹" +
                                                        numberWithCommas(toCalculateValueFromPercent(2, eachAllotment?.unitCost?.bsp))
                                                    }
                                                    disabled={true}
                                                />
                                            ) : (
                                                <CustomInput value={"₹0"} disabled={true} />
                                            )}
                                        </div>
                                        <div
                                            style={{ display: "flex", gap: "2rem" }}
                                        // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
                                        >
                                            <a
                                                href={`https://wa.me/${leadObj.leadcontactnumber}/?text=${eachAllotment.WhatsAppMessage}`}
                                                data-action="share/whatsapp/share"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <WhatsappIcon size={32} round={true} />
                                            </a>
                                        </div>
                                    </div>
                                    <div
                                        style={{ width: "100%", height: "100%", marginTop: "2rem" }}
                                    ></div>
                                </div>
                            );
                        })}
                    {showDetails && siteVisitData  && (
                        <div style={{ width: "100%", height: "30rem" }}>
                            <DataGrid
                                rows={siteVisitData}
                                columns={CpColumns}
                                sx={[dataGridStyles]}
                                getRowId={getRowId}
                                rowHeight={"30rem"}
                            />
                        </div>
                    )}
                </div>

                <div className={cssClasses.footer}>
                    {(
                        <div>
                            <Box>
                                {!showDetails ? (
                                    <Button
                                        iconPosition={"right"}
                                        padding={"0.5rem"}
                                        clicked={() => {
                                            setShowDetails(true);
                                        }}
                                        btnName={"More Details"}
                                        style={{
                                            color: "#1570EF",
                                            borderRadius: "2.4rem",
                                            backgroundColor: "#EFF8FF",
                                            fontSize: "1.6rem",
                                            lineHeight: "2.4rem",
                                            border: "1px solid #EFF8FF",
                                        }}
                                        btnIcon={
                                            <KeyboardArrowDownIcon
                                                style={{
                                                    color: "#1570EF",
                                                    width: "3rem",
                                                    height: "3rem",
                                                }}
                                            />
                                        }
                                    />
                                ) : (
                                    <Button
                                        iconPosition={"right"}
                                        padding={"0.5rem"}
                                        clicked={() => setShowDetails(false)}
                                        btnName={"Hide Details"}
                                        style={{
                                            color: "#1570EF",
                                            borderRadius: "2.4rem",
                                            backgroundColor: "#EFF8FF",
                                            fontSize: "1.6rem",
                                            lineHeight: "2.4rem",
                                            border: "1px solid #EFF8FF",
                                        }}
                                        btnIcon={
                                            <KeyboardArrowUpIcon
                                                style={{
                                                    color: "#1570EF",
                                                    width: "3rem",
                                                    height: "3rem",
                                                }}
                                            />
                                        }
                                    />
                                )}
                            </Box>
                        </div>
                    )
                    }

                    {
                        <a
                            href={`tel:+${leadObj.leadcontactnumber}`}
                            data-action="share/whatsapp/share"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <CallIcon
                                style={{ width: "3rem", height: "3rem" }}
                                size={32}
                                round={true}
                            />
                        </a>
                    }
                </div>
            </div>
            {openViewDetails && (
        <ViewSiteVisitDetails
          open={openViewDetails}
          handleClose={handleViewDetailsClose}
          data={ViewSiteData}
        />
      )}
        </Card>
    );
}


